<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">

	<div class="row my-4">
		<div *ngIf="form.contains('dateEntretien')" class="col-12 col-lg">
			<label for="dateEntretien" class="form-label fw-bold"
				>Date d'entretien</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateEntretien"
				name="dateEntretien"
				formControlName="dateEntretien"
				[ngClass]="{
					'is-invalid': dateEntretien.invalid,
					'is-valid': dateEntretien.dirty && dateEntretien.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="modaliteReunion" class="form-label fw-bold"
				>Modalité de réunion</label
			>
			<select
				id="modaliteReunion"
				class="form-select"
				name="modaliteReunion"
				formControlName="modaliteReunion"
				aria-label="Sélectionner une modalité de réunion"
				>
				<option *ngFor="let modaliteReunion of listModaliteReunion" value="{{ modaliteReunion.id }}">
					{{ modaliteReunion.name}}
				</option>
			</select>
		</div>
	</div>

	<!-- <div class="row my-4">
		<div class="col-12 col-lg">
			<label for="typeEntretien" class="form-label fw-bold"
				>Type d'entretien</label
			>
			<select
				id="typeEntretien"
				class="form-select"
				name="typeEntretien"
				formControlName="typeEntretien"
				aria-label="Sélectionner un type d'entretien"
				>
				<option *ngFor="let typeEntretien of listTypeEntretien" value="{{ typeEntretien.id }}">
					{{ typeEntretien.name}}
				</option>
			</select>
		</div>
	</div> -->

	<div class="row my-4">
		<div *ngIf="form.contains('description')" class="col-12 col-lg">
			<label for="description" class="form-label fw-bold"
				>Description</label
			>
			<textarea
				autocomplete="off"
				type="text"
				class="form-control"
				id="description"
				name="description"
				formControlName="description"
				[ngClass]="{
					'is-invalid': description.invalid,
					'is-valid': description.dirty && description.valid
							}"
			></textarea>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('dateProchainEntretien')" class="col-12 col-lg">
			<label for="dateProchainEntretien" class="form-label fw-bold"
				>Date du prochain entretien</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateProchainEntretien"
				name="dateProchainEntretien"
				formControlName="dateProchainEntretien"
				[ngClass]="{
					'is-invalid': dateProchainEntretien.invalid,
					'is-valid': dateProchainEntretien.dirty && dateProchainEntretien.valid
				}"
			/>
		</div>
	</div>

	<!-- <div class="row my-4">
		<div *ngIf="form.contains('username')" class="col-12 col-lg">
			<label for="username" class="form-label fw-bold"
				>Nom d'utilisateur</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputUsername"
				name="username"
				formControlName="username"
				[ngClass]="{
					'is-invalid': username.invalid,
					'is-valid': username.dirty && username.valid
				}"
			/>
		</div>
	</div> -->

<!-- 
	<div class="row my-4">
		<label for="expertises" class="form-label fw-bold">Expertise(s)</label>
		<div class="row">
			<div
				class="col-md-4 check"
				*ngFor="let expertise of listExpertise | orderBy : 'name' : 'asc'"
			>
				<div *ngIf="expertise.id !== 0">
					<input
						type="checkbox"
						name="{{ expertise.id }}"
						class="form-check-input"
						[value]="expertise"
						[checked]="isExpertiseCheck(expertise)"
						[ngClass]="{
							'theme-main-color-check': isExpertiseCheck(expertise)
						}"
						(change)="updateSelectedExpertise($event, expertise)"
					/>
					<label class="ms-2 form-check-label text-dark">
						{{ expertise.name }}
					</label>
				</div>
			</div>
		</div>
	</div> -->

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
